import { useEffect, useState } from 'react';
import { getClima, type ClimaActual } from '../services/weather';

/** Cada cuánto se vuelve a pedir. El modelo corre por hora; diez minutos sobra. */
const REFRESCO_MS = 10 * 60 * 1000;

/**
 * Condiciones y pronóstico de un punto.
 *
 * Lo usan el mapa del clima y el tablero. Que los dos pidan lo mismo no
 * duplica tráfico hacia afuera: el servidor guarda la respuesta por
 * coordenada redondeada, así que la segunda petición se contesta de memoria.
 */
export function useClima(lat: number | null, lng: number | null) {
  const [clima, setClima] = useState<ClimaActual | null>(null);
  const [cargado, setCargado] = useState(false);

  useEffect(() => {
    if (lat === null || lng === null) { setCargado(true); return; }
    let vivo = true;
    const traer = () =>
      getClima(lat, lng)
        .then(d => { if (vivo) setClima(d); })
        // Un 403 significa "este cliente no tiene el módulo de clima" y un
        // 502 que el proveedor no contestó. Ninguno es para alarmar: la
        // pantalla sigue, sin el dato.
        .catch(() => { if (vivo) setClima(null); })
        .finally(() => { if (vivo) setCargado(true); });
    traer();
    const reloj = setInterval(traer, REFRESCO_MS);
    return () => { vivo = false; clearInterval(reloj); };
  }, [lat, lng]);

  return { clima, cargado };
}
